import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-importar-excel',
  templateUrl: './importar-excel.component.html',
  styleUrls: ['./importar-excel.component.css']
})
export class ImportarExcelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0].path;

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    var stringBase64 = btoa(binaryString);
  //  this.compania.logo = this.stringBase64;
    console.log(btoa(binaryString));
  }


}
